import { render, staticRenderFns } from "./TestResultsChild.vue?vue&type=template&id=2aa43520&scoped=true"
import script from "./TestResultsChild.vue?vue&type=script&lang=js"
export * from "./TestResultsChild.vue?vue&type=script&lang=js"
import style0 from "./TestResultsChild.vue?vue&type=style&index=0&id=2aa43520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa43520",
  null
  
)

export default component.exports